import { render, staticRenderFns } from "./EditFormSubmit.vue?vue&type=template&id=38ef0431&"
import script from "./EditFormSubmit.vue?vue&type=script&lang=ts&"
export * from "./EditFormSubmit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports